import { render, staticRenderFns } from "./PcVideoOnlyPage.vue?vue&type=template&id=7c5fe53d&scoped=true"
import script from "./PcVideoOnlyPage.vue?vue&type=script&lang=ts"
export * from "./PcVideoOnlyPage.vue?vue&type=script&lang=ts"
import style0 from "./PcVideoOnlyPage.vue?vue&type=style&index=0&id=7c5fe53d&prod&lang=less&scoped=true"
import style1 from "./PcVideoOnlyPage.vue?vue&type=style&index=1&id=7c5fe53d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5fe53d",
  null
  
)

export default component.exports